import React from 'react';
import { Combo } from 'fw/forms';
import * as API from 'modules/app/API'

class DenialReasonCombo extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {};
        this._isMounted = false;
    }

    completed = () => { return this._ctrl.completed(); }
    flag = () => { return this._ctrl.flag(); }

	componentDidMount = () => {
		this._isMounted = true;

		API.Certification.get('/query/getDenialReasons', {},
			{
				success: (r) => {
					this._isMounted && this.setState({
						items: r.data.items.map((item) => { return { label: item.description, value: item.denialReasonId } })
					});
				}
			},
			{ block: false });
	}

	componentWillUnmount() {
		this._isMounted = false;
	}

    render() {
        return (
            <Combo
                {...this.props}
                placeholder="Select..."
                items={this.state.items}
                searchable={false}
                ref={(c) => { this._ctrl = c}} />
        )
    }
}

export default DenialReasonCombo;

// Mark this as a form component
DenialReasonCombo.defaultProps = {
    formControl: true,
    managed: false
};



// WEBPACK FOOTER //
// ./src/areas/shared/controls/denialReasonCombo/DenialReasonCombo.js